import { isSameDay } from 'date-fns';
import appConstant from "../../../../appConstants";
import {
  isShipmentsHasExcessiveLength,
  isDeliveryStopHasResunaPro,
  isStopHasCodShipments,
  isDeliveryStopHasExhibitPro
} from '../../../modules/Dispatch/utils/utils';
import { formatTime, getUTCDate } from '../../gridUtilities';
import { hasHoldRM } from '../../../modules/IBPlanning/RoutesView/utils';
import { getCustomerAndShipperComment } from '../../../modules/utils';
import { createDowSpecialNeeds } from '../../../../utilities/dowUtils';

const DropdownValueCellRenderer = (params) => {
  return params.value && params.value.label !== undefined
    ? params.value.label
    : params.value;
};

const getMinutes = (str) => {
  if (str) {
    const time = str.split(":");
    return time[0] * 60 + Number(time[1]);
  }
  return 0;
};

const checkIfETAInDeliveryRange = (etaTime, maxWaitingTimeAtStop) => (deliverySlot) => {
  const eta = getMinutes(etaTime);
  const [startTime, endTime] = deliverySlot.split("-");
  const startTimeInMinutes = getMinutes(startTime);
  const endTimeInMinutes = getMinutes(endTime);
  const etaWithWaitingTime = eta + parseInt(maxWaitingTimeAtStop);
  if (startTimeInMinutes <= etaWithWaitingTime && eta <= endTimeInMinutes) {
    return appConstant.STOP_STATUS.ONTIME;
   } else if (startTimeInMinutes >= etaWithWaitingTime && eta <= endTimeInMinutes) {
     return appConstant.STOP_STATUS.EARLY_ARRIVAL;
   } else {
   return appConstant.STOP_STATUS.DELAYED;
  }
};
const checkIsSameDayDelivery =(eta, plannedDate)=>{
  const etaDate = getUTCDate(eta);
  const planDate = getUTCDate(plannedDate);
  return isSameDay(etaDate, planDate);
}

const StopStatusCellRenderer = (params) => {
  if (params.data.stopType === appConstant.ROUTE_STOP_TYPES.AP) {
    return null;
  }
  let deliveryWindow = params.data.deliveryWindow || [];
  if (!Array.isArray(params.data.deliveryWindow)) {
    deliveryWindow = [deliveryWindow];
  }

  if (deliveryWindow.length !== 0) {
    if (!checkIsSameDayDelivery(params.data.eta, params.context.planDate )) {
      return appConstant.STOP_STATUS.DELAYED;
    }
    const statusList = deliveryWindow.map(
      checkIfETAInDeliveryRange(
        formatTime({ value: params.data.eta }),
        params.context.maxWaitingTimeAtStop
      )
    );
    if(statusList.includes(appConstant.STOP_STATUS.ONTIME)){
     return appConstant.STOP_STATUS.ONTIME
    }else if(statusList.includes(appConstant.STOP_STATUS.EARLY_ARRIVAL)){
      return appConstant.STOP_STATUS.EARLY_ARRIVAL
    }else{
      return appConstant.STOP_STATUS.DELAYED;
    }
  }
  return null;
};

const DisabledButtonRenderer = (params) => {
  return <span className="disabledContent">Disabled</span>;
};

/* ibplanning special need value getter used in stop/shipment grid */
const SpecialNeedsValueGetter = (params) => {
  const {
    priority,
    liftgate,
    eqptPref,
    specialNeeds,
    specialInstruction,
    shipmentSpecialInstruction,
    eqpmtPref,
    apt,
    excessiveLength,
    isCodCharge,
    isFreightCharge, 
    isTwoManRequired,
    isCargoVanEligible,
    isTrailerBackFill,
    isLgViolation,
    isTrailerSwap,
    isLiveUnLoad,
    isOnHold,
    isOnHoldRM,
    isUnattendedDelivery,
    deliveryDowOpen,
    isWhiteGloveDelivery,
    isNinvPro,
    isPhysicalDrRequired,
    isExhibitPro,
  } = params.data;
  const valuesArray = [apt, priority];
  const equipmentPrefs = eqptPref || eqpmtPref;
  equipmentPrefs &&
    equipmentPrefs
      .split(",")
      .map((equipmentPref) => valuesArray.push(equipmentPref));
  specialNeeds &&
    specialNeeds.split(",").map((specialNeed) => valuesArray.push(specialNeed));
  (specialInstruction || shipmentSpecialInstruction) && valuesArray.push(appConstant.SpecialNeedsStrings.SI);
  //Show liftgate icon only if the isLgViolation is false
  if (isLgViolation) {
    valuesArray.push(appConstant.SpecialNeedsStrings.LiftGateOverride);
  } else {
    valuesArray.push(liftgate);
  }

  (excessiveLength === appConstant.EXCESSIVE_SHIPMENT.YES && valuesArray.push(appConstant.SpecialNeedsStrings.ExcessiveLength));
  (isCodCharge || isFreightCharge) && valuesArray.push(appConstant.SpecialNeedsStrings.COD);
  isTwoManRequired && valuesArray.push(appConstant.SpecialNeedsStrings.TwoMan);
  isCargoVanEligible && valuesArray.push(appConstant.SpecialNeedsStrings.CargoVan);
  isTrailerBackFill === appConstant.TRAILER_BACKFILL.YES &&
    valuesArray.push(appConstant.SpecialNeedsStrings.TrailerBackFill);
  isTrailerSwap && valuesArray.push(appConstant.SpecialNeedsStrings.TrailerSwap);
  isLiveUnLoad && valuesArray.push(appConstant.SpecialNeedsStrings.LiveUnload);
  isWhiteGloveDelivery && valuesArray.push(appConstant.SpecialNeedsStrings.WhiteGloveDelivery);
  isNinvPro && valuesArray.push(appConstant.SpecialNeedsStrings.NINV);
  isPhysicalDrRequired && valuesArray.push(appConstant.SpecialNeedsStrings.PhysicalDR);
  isExhibitPro && valuesArray.push(appConstant.SpecialNeedsStrings.ExhibitPickup);
  if(isOnHoldRM || hasHoldRM(params.data)){
    valuesArray.push(appConstant.SpecialNeedsStrings.HoldRM);
  }else if(isOnHold){
     valuesArray.push(appConstant.SpecialNeedsStrings.Hold);
  }

  const { customerComments, shipperComments } = getCustomerAndShipperComment(params.data);
  customerComments && valuesArray.push(appConstant.SpecialNeedsStrings.CC);
  shipperComments && valuesArray.push(appConstant.SpecialNeedsStrings.SC);

  if(isUnattendedDelivery){
    valuesArray.push(appConstant.SpecialNeedsStrings.Unattended);
  }

  // Add DOW special needs if deliveryDowOpen is present
  if (deliveryDowOpen) {
    const planDate = params.context?.planDate;
    const dowSpecialNeeds = createDowSpecialNeeds(deliveryDowOpen, planDate);
    if (dowSpecialNeeds) {
      valuesArray.push(appConstant.SpecialNeedsStrings.DOW);
    }
  }

  return valuesArray.filter((data) => data);
};


const isPickupStopUnAcknowledged = (stop) => {
  return stop.stopType === appConstant.STOP_TYPE.Pickup && !stop.isAcknowledged;
};
const totalUnAckPickupsValueGetter = (params) => {
  const { stops } = params.data;
  return stops.filter(isPickupStopUnAcknowledged).length;
};

const isDeliveryShipmentsHasSpecialInstructions = (stopShipments) => {
  return (
    stopShipments?.some((shipment) =>
      shipment.specialInstructions || shipment.drComments?.length
    )
  );
};


/* dispatch special need getter used in pickup/driverInfoPopup grid and dispatch map */
const getSpecialNeeds = (params) => {
  const valuesArray = [];
  const {
    isApt,
    isFood,
    isPoison,
    isHazmat,
    isFreezable,
    isResidential,
    isLiftGate,
    isLimitedAccess,
    specialInstructions,
    priority,
    stopType,
    isLiftgateReqd,
    shipments = [],
    isExcessiveLength = false, //only for driverInfoPop's shipment stopType isExcessiveLength come at stop level
    isResunaDeliveryStop = false,
    isCodShipment = false,
    isTwoManRequired,
    isCargoVanEligible,
    isWhiteGloveDelivery,
    isNinvPro,
    isPhysicalDrRequired,
    isExhibitPro,
    maxEquipmentSize,
    minEquipmentSize,
    fixedEquipmentSize,
    shipperComments
  } = params.data;
  const isLiftgate = isLiftGate || isLiftgateReqd; 
  let hasSpecialInstruction = specialInstructions;
  const isDeliveryStopShipments = stopType === appConstant.STOP_TYPE.Delivery && shipments.length;
  isApt && valuesArray.push(appConstant.SpecialNeedsStrings.APT);
  isFood && valuesArray.push(appConstant.SpecialNeedsStrings.FD);
  isPoison && valuesArray.push(appConstant.SpecialNeedsStrings.PZ);
  isHazmat && valuesArray.push(appConstant.SpecialNeedsStrings.HZ);
  isFreezable && valuesArray.push(appConstant.SpecialNeedsStrings.FZ);
  isResidential && valuesArray.push(appConstant.SpecialNeedsStrings.RES);
  isLimitedAccess && valuesArray.push(appConstant.SpecialNeedsStrings.LA);
  isLiftgate && valuesArray.push(appConstant.SpecialNeedsStrings.L);
  priority?.length && valuesArray.push(...priority);
  if (
    hasSpecialInstruction ||
    (isDeliveryStopShipments && isDeliveryShipmentsHasSpecialInstructions(shipments))
  ) {
    valuesArray.push(appConstant.SpecialNeedsStrings.SI);
  }
  if (isExcessiveLength || isShipmentsHasExcessiveLength(shipments, stopType)) {
    valuesArray.push(appConstant.SpecialNeedsStrings.ExcessiveLength); //pickup grid /stop renderer/driverInfoPopup for stopType Delivery
  }
  if (isResunaDeliveryStop || isDeliveryStopHasResunaPro(shipments, stopType)) {
    valuesArray.push(appConstant.SpecialNeedsStrings.RESUNA); //pickup grid /stop renderer/driverInfoPopup for stopType Delivery
  }
  if(isCodShipment || isStopHasCodShipments(shipments)){
    valuesArray.push(appConstant.SpecialNeedsStrings.COD);
  }  
  if(isTwoManRequired ){
    valuesArray.push(appConstant.SpecialNeedsStrings.TwoMan);
  }  
  if(isCargoVanEligible){
    valuesArray.push(appConstant.SpecialNeedsStrings.CargoVan);
  }

  if(isWhiteGloveDelivery){
    valuesArray.push(appConstant.SpecialNeedsStrings.WhiteGloveDelivery);
  }
  if(isNinvPro){
    valuesArray.push(appConstant.SpecialNeedsStrings.NINV);
  }
  if(isPhysicalDrRequired){
    valuesArray.push(appConstant.SpecialNeedsStrings.PhysicalDR);
  }
  if(isExhibitPro || isDeliveryStopHasExhibitPro(shipments, stopType)){
    valuesArray.push(appConstant.SpecialNeedsStrings.ExhibitPickup);
  }

  if (maxEquipmentSize || minEquipmentSize || fixedEquipmentSize) {
    valuesArray.push(appConstant.SpecialNeedsStrings.EQS);
  }
  if(shipperComments){
    valuesArray.push(appConstant.SpecialNeedsStrings.SC);
  }
  return valuesArray;
};

/* dispatch special need value getter used only in driver grid */
const dispatchRoutesSpecialNeedsValueGetter = (params) => {
  const { stops } = params.data;
  let isApt,
    isFood,
    isPoison,
    isHazmat,
    isFreezable,
    isResidential,
    isLimitedAccess,
    isExcessiveLength,
    isResunaDeliveryStop,
    specialInstructions,
    isCodShipment,
    isLiftGate,
    isPhysicalDrRequired,
    isExhibitPro;
  let priority = [];

  if (stops.length > 0) {
    stops.forEach((stop) => {
      isApt |= stop.isApt;
      isFood |= stop.isFood;
      isPoison |= stop.isPoison;
      isHazmat |= stop.isHazmat;
      isFreezable |= stop.isFreezable;
      isResidential |= stop.isResidential;
      isLimitedAccess |= stop.isLimitedAccess;
      priority = stop.priority?.length
        ? [...priority, ...stop.priority]
        : priority;
      isExcessiveLength |= isShipmentsHasExcessiveLength(stop.shipments, stop.stopType);
      isResunaDeliveryStop |= isDeliveryStopHasResunaPro(stop.shipments, stop.stopType);
      isCodShipment |= isStopHasCodShipments(stop.shipments);
     specialInstructions |= isDeliveryShipmentsHasSpecialInstructions(stop.shipments);
     isLiftGate |= stop.isLiftGate;
     isPhysicalDrRequired |= stop.isPhysicalDrRequired;
     isExhibitPro |= isDeliveryStopHasExhibitPro(stop.shipments, stop.stopType);
    });
  }

  let paramsObj = {
    data: {
      isApt,
      isFood,
      isPoison,
      isHazmat,
      isFreezable,
      isResidential,
      isLimitedAccess,
      priority : [...new Set(priority)],
      isExcessiveLength,
      isResunaDeliveryStop,
      specialInstructions,
      isCodShipment,
      isLiftGate,
      isPhysicalDrRequired,
      isExhibitPro
    },
  };
  return getSpecialNeeds(paramsObj);
};

export {
  DropdownValueCellRenderer,
  StopStatusCellRenderer,
  DisabledButtonRenderer,
  SpecialNeedsValueGetter,
  totalUnAckPickupsValueGetter,
  getSpecialNeeds,
  dispatchRoutesSpecialNeedsValueGetter,
  isPickupStopUnAcknowledged,
  checkIsSameDayDelivery
};
